import { render, staticRenderFns } from "./order-detail-spu-list-item.vue?vue&type=template&id=3598dca1&scoped=true"
import script from "./order-detail-spu-list-item.vue?vue&type=script&lang=js"
export * from "./order-detail-spu-list-item.vue?vue&type=script&lang=js"
import style0 from "./order-detail-spu-list-item.vue?vue&type=style&index=0&id=3598dca1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598dca1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3598dca1')) {
      api.createRecord('3598dca1', component.options)
    } else {
      api.reload('3598dca1', component.options)
    }
    module.hot.accept("./order-detail-spu-list-item.vue?vue&type=template&id=3598dca1&scoped=true", function () {
      api.rerender('3598dca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/order-detail-spu-list-item.vue"
export default component.exports